(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-nav-roasteries')) {
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    class ShopNavRoasteries extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.panel = this.querySelector('.shop-nav__panel');
        this.closeButton = this.querySelector('.shop-nav__close');
        if (!this.details || !this.summary || !this.panel) return;

        this.setAttribute('data-enhanced', '');
        if (this.closeButton) this.closeButton.hidden = false;

        this.onToggle = this.onToggle.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onCloseClick = this.onCloseClick.bind(this);
        this.onFocusOut = this.onFocusOut.bind(this);
        this.onQueryChange = () => this.close(false);
        this.onPageShow = () => this.close(false);

        this.details.addEventListener('toggle', this.onToggle);
        this.addEventListener('focusout', this.onFocusOut);
        this.querySelectorAll('[data-shop-nav-close]').forEach((el) => el.addEventListener('click', this.onCloseClick));
        mobileQuery.addEventListener('change', this.onQueryChange);
        window.addEventListener('pageshow', this.onPageShow);
      }

      disconnectedCallback() {
        this.close(false);
        this.details?.removeEventListener('toggle', this.onToggle);
        mobileQuery.removeEventListener('change', this.onQueryChange);
        window.removeEventListener('pageshow', this.onPageShow);
      }

      onToggle() {
        if (this.details.open) {
          const modal = mobileQuery.matches;
          if (modal) {
            this.panel.setAttribute('role', 'dialog');
            this.panel.setAttribute('aria-modal', 'true');
            document.documentElement.style.overflow = 'hidden';
          }
          document.addEventListener('keydown', this.onKeydown);
          document.addEventListener('click', this.onDocumentClick);

          const target = this.panel.querySelector('[aria-current="page"]') || this.panel.querySelector('a');
          if (modal && target) target.focus({ preventScroll: true });
        } else {
          this.teardown();
        }
      }

      teardown() {
        this.panel.removeAttribute('role');
        this.panel.removeAttribute('aria-modal');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocumentClick);
      }

      close(returnFocus = true) {
        if (!this.details) return;
        if (this.details.open) this.details.open = false;
        this.teardown();
        if (returnFocus) this.summary.focus();
      }

      onCloseClick(event) {
        event.preventDefault();
        this.close();
      }

      /* Desktop popover closes when keyboard focus moves past it. */
      onFocusOut(event) {
        if (!this.details.open || mobileQuery.matches) return;
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close(false);
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }

        if (event.key !== 'Tab' || !mobileQuery.matches) return;

        // Keep focus inside the sheet while it is modal.
        const focusable = [...this.panel.querySelectorAll('a[href], button:not([hidden])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && (document.activeElement === first || !this.panel.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !this.panel.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    customElements.define('shop-nav-roasteries', ShopNavRoasteries);
  }

  } catch(e) { console.error(e); }
})();
})();
